var map = {
	"./anchor.png": 21,
	"./angel-wings.png": 22,
	"./arrow-dunk.png": 23,
	"./backward-time.png": 24,
	"./blade-drag.png": 25,
	"./book-cover.png": 26,
	"./brain.png": 27,
	"./broken-shield.png": 28,
	"./bubbles.png": 29,
	"./campfire.png": 30,
	"./candle-holder.png": 31,
	"./cash.png": 32,
	"./crossed-chains.png": 33,
	"./electric.png": 34,
	"./empty-hourglass.png": 35,
	"./eyelashes.png": 36,
	"./fangs.png": 37,
	"./fireflake.png": 38,
	"./flame.png": 39,
	"./fluffy-cloud.png": 40,
	"./footsteps.png": 41,
	"./gears.png": 9,
	"./hazard-sign.png": 42,
	"./high-shot.png": 43,
	"./holy-water.png": 44,
	"./hood.png": 45,
	"./horseshoe.png": 46,
	"./key.png": 47,
	"./liberty-wing.png": 48,
	"./lightning-storm.png": 49,
	"./lightning-tear.png": 50,
	"./magnifying-glass.png": 51,
	"./moon-bats.png": 52,
	"./night-sleep.png": 53,
	"./pentacle.png": 54,
	"./perspective-dice-six-faces-six.png": 55,
	"./plain-arrow.png": 56,
	"./potion-ball.png": 57,
	"./pouring-chalice.png": 58,
	"./rolling-bomb.png": 59,
	"./shamrock.png": 60,
	"./sheep.png": 61,
	"./shiny-apple.png": 62,
	"./snake.png": 63,
	"./snowflake-2.png": 64,
	"./spectre.png": 65,
	"./stone-pile.png": 66,
	"./swords-emblem.png": 67,
	"./tombstone.png": 68,
	"./torch.png": 69,
	"./treasure-map.png": 70,
	"./tree-branch.png": 71,
	"./witch-flight.png": 72
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 10;